import { render } from "./StructureDetailView.vue?vue&type=template&id=cb7416a6&scoped=true"
import script from "./StructureDetailView.vue?vue&type=script&lang=js"
export * from "./StructureDetailView.vue?vue&type=script&lang=js"

import "./StructureDetailView.vue?vue&type=style&index=0&id=cb7416a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb7416a6"]])

export default __exports__